var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",on:{"click":_vm.clicked}},[_c('p',{staticClass:"action-button",class:{ 'orange-gradient': !_vm.isBusy, 'wriggle': _vm.wrongQrCode },attrs:{"disabled":_vm.isBusy}},[_c('i',{staticClass:"fas",class:_vm.iconClass}),_vm._v(" \n    "+_vm._s(_vm.buttonLabel)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c243b88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/HomeButton.vue
// module id = 74
// module chunks = 0